import { FiltroConsultaHistoricoMsj, FiltroConsultaHistoricoRta, HistoricoMensaje, HistoricoRespuesta} from "../modelo/ReporteHistoricoModelo";

export const CONSULTAR_HISTORICOS_RESPUESTAS = "CONSULTAR_HISTORICOS_RESPUESTAS";
export const CONSULTAR_HISTORICOS_MENSAJES = "CONSULTAR_HISTORICOS_MENSAJES";

export const TABLA_MENSAJES_CONSULTADOS = "TABLA_MENSAJES_CONSULTADOS";
export const TABLA_RESPUESTAS_CONSULTADOS = "TABLA_RESPUESTAS_CONSULTADOS";

export const ERROR_CONSULTANDO_TABLA_MENSAJE = "ERROR_CONSULTANDO_TABLA_MENSAJE";
export const ERROR_CONSULTANDO_TABLA_RESPUESTA = "ERROR_CONSULTANDO_TABLA_RESPUESTA";

export const DESCARGAR_XLS_TABLA_HISTORICO_MSJ = "DESCARGAR_XLS_TABLA_HISTORICO_MSJ";
export const EXITO_DESCARGAR_TABLAS_HISTORICOS_MSJ_XLS = "EXITO_DESCARGAR_TABLAS_HISTORICOS_MSJ_XLS";
export const ERROR_DESCARGAR_TABLAS_HISTORICOS_MSJ_XLS = "ERROR_DESCARGAR_TABLAS_HISTORICOS_MSJ_XLS";

export const consultarHistoricosMensaje = (filtro: FiltroConsultaHistoricoMsj) => ({ type: CONSULTAR_HISTORICOS_MENSAJES, filtro});
export const consultarHistoricosRespuesta = (filtro: FiltroConsultaHistoricoRta) => ({ type: CONSULTAR_HISTORICOS_RESPUESTAS, filtro});

export const tablaMensajesConsultados = (datosRespuesta: Array<HistoricoMensaje>, paginas: number, totalDatos: number) => ({ 
    type: TABLA_MENSAJES_CONSULTADOS, datosRespuesta, paginas, totalDatos });
export const tablaRespuestasConsultados = (datosRespuesta: Array<HistoricoRespuesta>, paginas: number, totalDatos: number) => ({ 
    type: TABLA_RESPUESTAS_CONSULTADOS, datosRespuesta, paginas, totalDatos });

export const errorConsultandoTablaMensaje = () => ({ type: ERROR_CONSULTANDO_TABLA_MENSAJE });
export const errorConsultandoTablaRespuesta = () => ({ type: ERROR_CONSULTANDO_TABLA_RESPUESTA });

export const descargarXLSTablaHistoricoMsj = (filtro: FiltroConsultaHistoricoMsj) => ({ type: DESCARGAR_XLS_TABLA_HISTORICO_MSJ, filtro});
export const exitoDescargarTablaHistoricoMsjXLS = () => ({ type: EXITO_DESCARGAR_TABLAS_HISTORICOS_MSJ_XLS});
export const errorDescargarTablasHistoricoMsjXLS = () => ({ type: ERROR_DESCARGAR_TABLAS_HISTORICOS_MSJ_XLS});


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/consulta_tabla_historicos/modulos/consultaHistoricosActions.ts